import { useDispatch, useSelector } from 'react-redux';
import { Box, Center, Row, Typography } from '@tempmee/react';
import { changeHubFilter } from '../../../../actions';
// NOTE(DS migration): InputSelect is a commonComponents form control. The DS equivalent is
// InputSelectField, but its API differs (FormField wrapper, value/onChange shape) — deferred to
// the "form components" migration category and kept as-is for now.
import { InputSelect } from '../../../../commonComponents';
import { UserProfession } from '../../../../enums/UserProfession';
import { SolidUserIcon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';

export const FilterSelect = () => {
  const dispatch = useDispatch();
  const filter = useSelector((state) => state.user.professionalHubFilter);

  return (
    <Row gap={1}>
      <Center width="120px">
        <Row gap={1} width="120px">
          <SolidUserIcon color={colors.secondary[500]} />
          <Typography bold size="body_large">
            Filter by:
          </Typography>
        </Row>
      </Center>

      <Box width="220px">
        <InputSelect
          dataCy="input-profession-filters"
          value={filter}
          setValue={(option) => dispatch(changeHubFilter(option))}
          options={options}
          isSelectVisible={false}
        />
      </Box>
    </Row>
  );
};

const options = [
  { title: 'All Professionals', value: 'all' },
  { title: 'Dental Hygienist', value: UserProfession.RDH },
  { title: 'Dental Assistant', value: UserProfession.DA },
  { title: 'Associate Dentist', value: UserProfession.DN },
  { title: 'Front Desk', value: UserProfession.FD },
];
